module.exports = require("@amplitude/unified");